import PropTypes from "prop-types"

const NpsShape = {
  currentReviewYearSummary: PropTypes.object,
  previousYears: PropTypes.array,
  percentage: PropTypes.number,
}
export default NpsShape



// WEBPACK FOOTER //
// ./src/state/shapes/NpsShape.js